import styled from "styled-components";

export const StyledCopyrightMobile = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 48px 0 28px;
`;